<script lang="ts">
	import type { DataType } from "#gen/common/v1/types_pb.js";
	import { getDataTypeString } from "#lib/components/flow/editor/data-types/dataTypes.js";

	interface Props {
		dataType: DataType;
	}

	const { dataType }: Props = $props();
</script>

<div class="inline-block rounded-sm bg-gray-100 px-2.5 py-0.5 text-center">
	{getDataTypeString(dataType)}
</div>
